module.exports = __webpack_public_path__ + "static/img/szafa_12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_12.svg
// module id = s8el
// module chunks = 0